import React from "react";
const Search = (props) => {
  const {
    divstyle,
    inputstyle,
    // iconstyle,
    placeHolder,
    searchFunc,
    innerwrapper,
  } = props;
  return (
    <div className={divstyle}>
      <div className={innerwrapper}>
        <input
          type="search"
          className={inputstyle}
          placeholder={placeHolder}
          onChange={searchFunc}
        />
        {/* <button className={iconstyle} type="submit">
          Search
        </button> */}
      </div>
    </div>
  );
};

export default Search;
